<h1 mat-dialog-title>
  <strong>{{ title }}</strong>
</h1>

<div mat-dialog-content>
  <p>{{ message }}</p>
  @if (!!warn) {
  <p class="text-danger">{{ warn }}</p>
  }
</div>

<mat-dialog-actions align="end">
  <button mat-raised-button mat-dialog-close>Annuler</button>
  <button mat-raised-button [color]="buttonColor" (click)="confirm()">{{ action }}</button>
</mat-dialog-actions>
